import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const CascaderMeta: ComponentMeta = {
  componentName: "Cascader",
  package: "@mijadesign/web",
  title: "级联选择器",
  description: "多级联动选择器，用于从多级数据中选择",
  category: ComponentCategory.FORM,
  icon: "ApartmentOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "options",
      label: "选项数据",
      type: PropType.JSON,
      description:
        '级联数据，如：[{ value: "1", label: "选项1", children: [] }]',
      group: "数据",
    },
    {
      name: "value",
      label: "选中值",
      type: PropType.ARRAY,
      group: "数据",
    },
    {
      name: "placeholder",
      label: "占位提示",
      type: PropType.STRING,
      defaultValue: "请选择",
      group: "基础",
    },
    {
      name: "allowClear",
      label: "可清空",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "功能",
    },
    {
      name: "multiple",
      label: "多选",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "showSearch",
      label: "显示搜索",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "expandTrigger",
      label: "展开方式",
      type: PropType.ENUM,
      defaultValue: "click",
      options: [
        { label: "点击", value: "click" },
        { label: "悬停", value: "hover" },
      ],
      group: "行为",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "middle",
      options: [
        { label: "大", value: "large" },
        { label: "中", value: "middle" },
        { label: "小", value: "small" },
      ],
      group: "样式",
    },
  ],
  defaultProps: {
    placeholder: "请选择",
    allowClear: true,
    expandTrigger: "click",
    size: "middle",
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Cascader",
  },
  snippet: {
    componentName: "Cascader",
    package: "@mijadesign/web",
    props: {
      placeholder: "请选择",
      options: [
        {
          value: "zhejiang",
          label: "浙江",
          children: [
            { value: "hangzhou", label: "杭州" },
            { value: "ningbo", label: "宁波" },
          ],
        },
        {
          value: "jiangsu",
          label: "江苏",
          children: [
            { value: "nanjing", label: "南京" },
            { value: "suzhou", label: "苏州" },
          ],
        },
      ],
    },
  },
};
